import hyperdom from 'hyperdom'
import qs from 'qs'
import clone from 'root-core/utils/object/clone.js'
import * as constants from 'root-config/constants.js'
import * as gtmDataLayer from '../../../analytics/gtm/dataLayer.js'

class UpliftCallbacks {
  constructor ({bookingEngineUrl = '/', paymentServicesUrl, upliftContainer, browserCapabilities} = {}) {
    this.bookingEngineUrl = bookingEngineUrl
    this.paymentServicesUrl = paymentServicesUrl
    this.upliftContainer = upliftContainer
    this.browserCapabilities = browserCapabilities
  }

  load ({tripInfo, onLoad, upliftRejected}) {
    this.upliftApi.load(tripInfo, ({show_iframe}) => {
      onLoad(show_iframe && !upliftRejected, {api: this.upliftApi})
    })
  }

  update ({tripInfo, onUpdate}) {
    this.upliftApi.update(tripInfo, ({show_iframe}) => {
      onUpdate(show_iframe)
    })
  }

  getTripInfo ({quoteCriteria, booking, bookingType}) {
    this.quoteCriteria = quoteCriteria
    this.booking = booking
    this.bookingType = bookingType
    const leadPassenger = booking.leadPassenger
    let insuranceSum = 0
    const insuranceAvailable = quoteCriteria.passengers.some(passenger => passenger.travelProtection)
    quoteCriteria.passengers.map(passenger => {
      if (passenger.travelProtection) {
        let price = passenger.ontarioResident ? passenger.travelProtectionPlan.price * (1 + constants.ontarioTravelProtectionTax)
          : passenger.travelProtectionPlan.price
        insuranceSum = insuranceSum + price
      }
    })

    const tripInfo = {
      order_amount: Math.round(booking.totalAmount * 100),
      travelers: quoteCriteria.passengers.map((passenger, idx) => {
        return {
          first_name: passenger.firstName,
          last_name: passenger.lastName,
          id: idx,
          date_of_birth: passenger.dateOfBirth ? passenger.dateOfBirth : '',
        }
      }),
      billing_contact: {
        phone: `${leadPassenger.phoneNumber.areaCode} ${leadPassenger.phoneNumber.number}`,
        email: booking.leadPassenger.emailAddress,
        street_address: `${booking.leadPassenger.address.line1}`,
        city: `${booking.leadPassenger.address.city}`,
        region: `${booking.leadPassenger.address.region}`,
        postal_code:`${booking.leadPassenger.address.postcode}`,
      },
      hotel_reservations: [{
        hotel_name: `${quoteCriteria.departure.name} (${quoteCriteria.departure.productCode})`,
        check_in: quoteCriteria.departure.startDate.toISOString().substring(0, 10).split('-').join(''),
        check_out: quoteCriteria.departure.endDate.toISOString().substring(0, 10).split('-').join(''),
        number_of_rooms: 1,
      }],
    }

    if (insuranceAvailable) {
      tripInfo.hotel_reservations[0].insurance = [{
        types: ['cancellation'],
        price: insuranceSum * 100,
      }]
    }
    return tripInfo
  }

  getMonthlyAmount (){
    let amount = this.upliftApi.getMonthlyAmount()
    if (typeof amount === 'string') {
      amount = Number.parseFloat(amount.replace(',', ''))
    }
    if (Number.isNaN(amount)) amount = 0
    return amount
  }

  onadd () {
    gtmDataLayer.activateOptimize()
    const containerContainer = document.getElementById('uplift-container-container')
    this.upliftContainer.style.display = 'block'
    containerContainer.appendChild(this.upliftContainer)
    this.upliftApi.select()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  onbeforeremove () {
    this.upliftApi.deselect()
    this.upliftContainer.style.display = 'none'
    document.body.appendChild(this.upliftContainer)
  }

  renderPsIframe (onload = () => {}) {
    const billingAddress = clone(this.quoteCriteria.leadPassenger.address)
    const search = {
      postMessage: true,
      cardTypes: 'MASTERCARD',
      amount: this.booking.totalAmount,
      bookingType: this.bookingType,
      bill_to_email: this.quoteCriteria.leadPassenger.emailAddress,
      bill_to_address_line1: billingAddress.line1,
      bill_to_address_line2: billingAddress.line2,
      bill_to_address_city: billingAddress.city,
      bill_to_address_state_name: billingAddress.region,
      bill_to_address_country: this.quoteCriteria.config.upliftLocale ? this.quoteCriteria.config.upliftLocale.substr(3) : 'US',
      bill_to_address_postal_code: billingAddress.postcode,
      comments: 'Customer paid using Uplift',
    }
    const {sellingCompanyCode, bookingId} = this.booking
    const psIframeUrl = `${this.bookingEngineUrl}proxy/ps-iframe/${sellingCompanyCode}/${bookingId}?${qs.stringify(search)}`
    return <iframe width='1px' height='1px' frameBorder='0' id='psHiddenForm' onload={onload} src={psIframeUrl} style={this.browserCapabilities.input.ignoresAutoCompleteFlag ? 'display:none' : ''} />
  }

  orderError (reason) {
    this.upliftApi.orderError(reason)
  }

  orderConfirmation (customerReference){
    this.upliftApi.orderConfirmation(customerReference)
  }

  processPayment (){
    const card = this.upliftApi.getVirtualCard()
    const form = document.querySelector('#psHiddenForm').contentDocument.querySelector('form')
    try {
      if (form) {
        form.querySelector('input[name=card_number]').value = card.card_number
        form.querySelector('input[name=card_cvn]').value = card.card_ccv
        form.querySelector('input[name=card_type]').value = (card.card_number.startsWith('4'))?'001':'002'
        form.querySelector('input[name=card_expiry_date]').value = `${card.expiration_month}-${card.expiration_year}`.padStart(7, '0')
        form.querySelector('input[name=bill_to_forename]').value = card.contact.first_name
        form.querySelector('input[name=bill_to_surname]').value = card.contact.last_name
        form.querySelector('input[name=bill_to_address_line1]').value = card.contact.street_address
        form.querySelector('input[name=bill_to_address_city]').value = card.contact.city
        form.querySelector('[name=bill_to_address_state]').value = card.contact.region
        form.querySelector('[name=bill_to_address_country]').value = card.contact.country
        form.querySelector('input[name=bill_to_address_postal_code]').value = card.contact.postal_code
        form.querySelector('input[name=checkbox_tc-policy]').checked = true
        form.querySelector('[id=expiry-month-card-number]').value = `${card.expiration_month}`.padStart(2,'0')
        form.querySelector('[id=expiry-month-card-number]').click()
        form.querySelector('[id=expiry-year-card-number]').value = `${card.expiration_year}`.substring(2)
        form.querySelector('[id=expiry-year-card-number]').click()
        Array.prototype.slice.call(form.querySelectorAll('[data-validation]')).forEach(element => {
          element.removeAttribute('data-validation')
        })
        form.querySelector('button[type=submit]').click()
      } else {
        throw new Error('Payment Services form loading error')
      }
    } catch (e) {
      console.error(e.message)
    }
  }
}

class Uplift extends UpliftCallbacks {
  constructor ({paymentServicesUrl, upliftContainer, browserCapabilities}) {
    super({paymentServicesUrl, upliftContainer, browserCapabilities})
    this.upliftApi = window.UpLift.Payments
  }

  render () {
    return <div>
      {this.renderPsIframe()}
      <div id="uplift-container-container"></div>
    </div>
  }
}

class FakeUpliftApi {
  constructor ({
    expectedCardDetails,
    expectedMonthlyAmount,
    upliftContainer,
    upliftApiKey,
    showProceedWithBooking,
    creditDenied,
  }) {
    window.UpLift = {Payments:this}
    this.expectedCardDetails = expectedCardDetails
    this.expectedMonthlyAmount = expectedMonthlyAmount
    this.modalCallbackRegistered = false

    window.upReady = () => {
      window.UpLift.Payments.init({
        apiKey: upliftApiKey,
        checkout: true,
        container: `#${upliftContainer.id}`,
        onRejected: () => creditDenied(),
        onRejectedContinue: () => creditDenied(),
        onApproved: () => {},
        onPaymentReady: () => showProceedWithBooking(true),
        onPaymentUnready: () => showProceedWithBooking(false),
      })
    }
  }

  addInfoToNode () {
    this.modalCallbackRegistered = true
  }

  init ({onPaymentReady, onRejected, onRejectedContinue}) {
    this.onPaymentReady = onPaymentReady
    this.onRejected = onRejected
    this.onRejectedContinue = onRejectedContinue
  }

  getVirtualCard () {
    return this.expectedCardDetails
  }

  load (tripInfo, onLoaded) {
    this.actualTripInfo = tripInfo
    setTimeout(() => onLoaded({show_iframe: true}), 500)
  }

  update (tripInfo, onLoaded) {
    this.actualTripInfo = tripInfo
    onLoaded({show_iframe: true})
  }

  select () {}

  deselect () {}

  orderError (reason) {this.lastFailedReason = reason}

  orderConfirmation (customerReference) {this.customerReference =  customerReference}

  getMonthlyAmount (){
    return this.expectedMonthlyAmount
  }
}

class FakeUplift extends UpliftCallbacks {
  constructor ({
    expectedCardDetails,
    bookingEngineUrl,
    expectedMonthlyAmount,
    paymentServicesUrl,
    approveCredit,
    upliftContainer,
    upliftApiKey,
    showProceedWithBooking,
    creditDenied,
    browserCapabilities,
  }) {
    super({
      bookingEngineUrl,
      paymentServicesUrl,
      upliftContainer,
      browserCapabilities,
    })

    this.approveCredit = approveCredit
    this.upliftApi = new FakeUpliftApi({
      expectedCardDetails,
      expectedMonthlyAmount,
      upliftContainer,
      upliftApiKey,
      showProceedWithBooking,
      creditDenied,
    })

    window.upReady()
  }

  render () {
    return <div>
      {this.renderPsIframe(() => {
        this.psIframeLoaded = true
        this.refresh()
      })}
      <div id="uplift-container-container">
        {
          this.psIframeLoaded
            ? <button onclick={() => {this.approveCredit ?  this.upliftApi.onPaymentReady() : this.upliftApi.onRejectedContinue()}}>Confirm Loan</button>
            : undefined
        }
      </div>
    </div>
  }
}

async function importUpliftLibrary ({upliftApiKey, upliftCode, upliftLocale, upliftCurrency, showProceedWithBooking, creditDenied}) {
  const upliftContainerId = 'uplift-container'
  if (window.upReady) {
    return Promise.resolve(document.getElementById(upliftContainerId))
  }

  window.up = function () {
    window.up.q.push(arguments)
  }
  window.up.q = []
  window.up.l = 1 * new Date
  window.up('create', upliftCode)

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = 1
    script.onerror = function () {
      reject()
    }
    window.upReady = function () {
      const upliftContainer = document.createElement('div')
      upliftContainer.id = upliftContainerId
      upliftContainer.style.display = 'none'
      document.body.appendChild(upliftContainer)

      window.UpLift.Payments.init({
        apiKey: upliftApiKey,
        checkout: true,
        locale: upliftLocale,
        currency: upliftCurrency,
        container: `#${upliftContainer.id}`,
        onRejected: () => creditDenied(),
        onRejectedContinue: () => {},
        onApproved: () => {},
        onPaymentReady: () => showProceedWithBooking(true),
        onPaymentUnready: () => showProceedWithBooking(false),
      })
      resolve(upliftContainer)
    }
    script.text = `(function(u,p,l,i,f,t,b,j){u['UpLiftPlatformObject']=f;u[f]=u[f]||function(){(u[f].q=u[f].q||[]).push(arguments)},u[f].l=1*new Date();b=p.createElement(l),j=p.getElementsByTagName(l)[0];b.async=1;b.src=i+'?id='+t;j.parentNode.insertBefore(b,j);let o=window.location.host.match(/[w-]+.w{2,3}(:d+)?$/);if(o)o=o[0];u[f]('create',t,o)})(window,document,'script','//cdn.uplift-platform.com/a/up.js','up','${upliftCode}')`
    document.head.appendChild(script)
  }).then((container) => {
    return container
  })
}

export default async function (
  {fakeUplift, upliftApiKey, upliftCode, upliftLocale, upliftCurrency, paymentServicesUrl} = {},
  {showProceedWithBooking, creditDenied} = {},
  browserCapabilities) {
  if (fakeUplift) {
    const upliftContainer = document.createElement('div')
    upliftContainer.id = 'uplift-container'
    upliftContainer.style.display = 'none'
    document.body.appendChild(upliftContainer)

    fakeUplift.showProceedWithBooking = showProceedWithBooking
    fakeUplift.creditDenied = creditDenied
    fakeUplift.paymentServicesUrl = paymentServicesUrl
    fakeUplift.upliftContainer = upliftContainer
    fakeUplift.upliftApiKey = upliftApiKey
    fakeUplift.browserCapabilities = browserCapabilities
    return new FakeUplift(fakeUplift)
  } else {
    const upliftContainer = await importUpliftLibrary({
      upliftApiKey,
      upliftCode,
      upliftLocale,
      upliftCurrency,
      showProceedWithBooking,
      creditDenied,
    })
    return new Uplift({paymentServicesUrl, upliftContainer, browserCapabilities})
  }
}
